var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M942.08 901.12L819.2 778.24c27.306667-40.96 44.373333-88.746667 44.373333-139.946667 0-133.12-109.226667-238.933333-238.933333-238.933333s-238.933333 109.226667-238.933333 238.933333c0 133.12 109.226667 238.933333 238.933333 238.933334 51.2 0 98.986667-13.653333 139.946667-44.373334L887.466667 955.733333c6.826667 6.826667 17.066667 10.24 27.306666 10.24s20.48-3.413333 27.306667-10.24c6.826667-6.826667 10.24-17.066667 10.24-27.306666s-3.413333-20.48-10.24-27.306667z m-320.853333-102.4c-88.746667 0-160.426667-71.68-160.426667-160.426667s71.68-160.426667 160.426667-160.426666 160.426667 71.68 160.426666 160.426666-71.68 160.426667-160.426666 160.426667z",
    fill: "#F4A914"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M931.84 0H92.16C51.2 0 17.066667 34.133333 17.066667 75.093333v870.4c0 40.96 34.133333 75.093333 75.093333 75.093334h638.293333c23.893333 0 40.96-17.066667 40.96-40.96s-17.066667-40.96-40.96-40.96H98.986667V81.92h829.44v665.6c0 23.893333 17.066667 40.96 40.96 40.96s40.96-17.066667 40.96-40.96V75.093333C1006.933333 34.133333 972.8 0 931.84 0z",
    fill: "#3366CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.933333 273.066667h546.133334c23.893333 0 40.96-17.066667 40.96-40.96s-17.066667-40.96-40.96-40.96H238.933333c-23.893333 0-40.96 17.066667-40.96 40.96C197.973333 252.586667 215.04 273.066667 238.933333 273.066667zM314.026667 406.186667H238.933333c-23.893333 0-40.96 17.066667-40.96 40.96s17.066667 40.96 40.96 40.96h75.093334c23.893333 0 40.96-17.066667 40.96-40.96s-20.48-40.96-40.96-40.96z",
    fill: "#3366CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.c306d5d603cb289033a14c71a4ba988d.svg";
export { ForwardRef as ReactComponent };